import React, { ReactElement } from 'react';
import { useMutation } from '@apollo/client';
import EditProfileForm from '../components/EditProfileForm';
import UPDATE_ME_PROFILE from 'graph/user/update-me-profile-mutation';
import useStore from 'store';
import { VoidCallback } from 'types';

interface EditProfileModalProps {
  onClose: VoidCallback;
  onSubmitError?: VoidCallback;
  onSubmitSuccess?: VoidCallback;
}

const EditProfileModal = (props: EditProfileModalProps): ReactElement => {
  const [updateMe] = useMutation(UPDATE_ME_PROFILE);
  const [{ user }] = useStore();

  return <EditProfileForm {...props} {...user?.me} updateMe={updateMe} />;
};

export default EditProfileModal;
